<template>
	<div>
		<img src="../../../public/pic/company/company3.png" style="vertical-align: middle;width: 100%;"/>
		<div class="center_sun" style="width: 90%;">
			<div>
				<h2>
				<i class="el-icon-s-grid" >
					{{ $t('lang.News')}}
				</i>
				</h2>
			</div>
			<div style="margin-top: 20px;text-align: left;">
				
				<div v-show="this.$i18n.locale == 'zh'">
					<el-card v-for="item in data" class="box-card black_background" :key="item.id" style="margin-bottom: 40px;">
						<div v-on:click='handle(item.id)'>
							<h2 class="blackfont oneline">{{item.title}}</h2>
							<p class="blackfont indent twoline" >{{item.content}}</p>
							<p class="blackfont">{{item.date}}</p>
						</div>
					</el-card>
				</div>
				<div v-show="this.$i18n.locale == 'en'">
					<el-card v-for="item in data" class="box-card black_background" :key="item.id" style="margin-bottom: 40px;">
						<div v-on:click='handle(item.id)'>
							<h2 class="blackfont oneline">{{item.titleEn}}</h2>
							<p class="blackfont indent twoline" >{{item.contentEn}}</p>
							<p class="blackfont">{{item.date}}</p>
						</div>
					</el-card>
				</div>
			
				
				<div class="block" >
					<el-pagination style="color: white;" background
						layout="prev, pager, next"
						:total="total" :current-page="current">
					</el-pagination>
				</div>
			
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data : '',
			current : 1,
			limit : 10,
			total : 0,
			
		};
	},
	created(){
		var url = this.baseUrl+"news/find_news_list";
		this.axios({
			// 默认请求方式为get
			method: 'get',
			url: url,
			// 传递参数
			params: {
				current : this.current,
				limit : this.limit,
			},
		}).then(response => {
			// 请求成功
			//console.log(JSON.stringify(response));
			this.data = response.data.data;
			//console.log(response.data.data);
		}).catch(error => {
			error.constructor
			// 请求失败，当then种出错就进入这里
			//console.log("请求失败"+JSON.stringify(error));
			
		});
		
			
		
	},
	methods:{
		handle:function(id){
			//<router-link :to="{ path: 'dynamic_details', query: { item: {item}}}">
			
			this.$router.push({ path: 'dynamic_details1', query: { id: id }});
		}
	},
	head(){
		return {
			title : '新闻动态_深圳全智能机器人科技有限公司                  News updates---Shenzhen AI-tech CO.,LTD',
			keywords : '机器人行业动态,机器人技术与应用，机器人行业发展前景,机器人行业发展现状,机器人行业龙头,机器人行业怎么样                     。Robot industry trends, robot technology and application, robot industry development prospects, robot industry development status, robot industry leader, how about robot industry',
			description : '深圳全智能机器人科技有限公司主要是主要是研发、生产、销售人工智能技术服务、软件、硬件平台和智能产品。产品可以广泛用于教育、军事、医疗、商务、交通、养老监护和智能家居等领域。公司所研发生产的迎宾机器人、情侣机器人、消毒机器人与送餐机器人等。全部可根据需求定制，提供专属的设计方案。AI-Tech is mainly focused on research and development, production and sales of artificial intelligence technology services, software, hardware platform and intelligent products. Products can be widely used in education, military, medical, business, transportation, old-age care and smart home and other fields. The company developed and produced welcome robots, companion robots, disinfection robots and meal delivery robots. All can be customized to meet the needs of the design.',
			};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
	
	img{
	
	position:relative;
	
	clear:both;
	
	width:100%;
	
	height:100%;
	
	}
	
	p{
		color: white;
	}
	
	
	
	
</style>
